module.exports = __webpack_public_path__ + "img/63.d2b593ad.svg";